import React from "react";

import {
    LabeledField,
    SectionCard,
    Select,
    Stack,
    TimeField,
    ToggleSwitch,
} from "shared/ui";
import { toTimeString } from "shared/lib/timeSlot";

import { TIMEZONE_OPTIONS, WEEK_DAYS } from "features/MenuSettings/constants";
import { useMenuSettingsContext } from "features/MenuSettings/context";

import { DayRow, DayTimes, DayToggle } from "../styles";

export const WorkingScheduleCard = () => {
    const { general } = useMenuSettingsContext();

    if (!general.workingSchedule) return null;

    return (
        <SectionCard
            title="Режим работы"
            description="Расскажите вашим клиентам когда вы работаете."
        >
            <Stack>
                <LabeledField label="Часовой пояс">
                    <Select
                        value={general.workingSchedule.timezoneInMinutes}
                        onChange={(value) => general.setTimezone(Number(value))}
                        options={TIMEZONE_OPTIONS}
                    />
                </LabeledField>

                {WEEK_DAYS.map((day) => {
                    const daySchedule = general.workingSchedule[day.key];
                    const slot = general.getDaySlot(day.key);

                    return (
                        <DayRow key={day.key}>
                            <DayToggle>
                                <ToggleSwitch
                                    checked={!daySchedule.isDayOff}
                                    onChange={(checked) =>
                                        general.setDayOff(day.key, !checked)
                                    }
                                    label={day.label}
                                />
                            </DayToggle>
                            <DayTimes>
                                <LabeledField label="С">
                                    <TimeField
                                        value={toTimeString(slot.fromHour, slot.fromMinute)}
                                        disabled={daySchedule.isDayOff}
                                        onChange={(value) =>
                                            general.setDayTime(day.key, "from", value)
                                        }
                                    />
                                </LabeledField>
                                <LabeledField label="До">
                                    <TimeField
                                        value={toTimeString(slot.toHour, slot.toMinute)}
                                        disabled={daySchedule.isDayOff}
                                        onChange={(value) =>
                                            general.setDayTime(day.key, "to", value)
                                        }
                                    />
                                </LabeledField>
                            </DayTimes>
                        </DayRow>
                    );
                })}
            </Stack>
        </SectionCard>
    );
};
